import { useState } from 'react';

export const useFormTools = () => {
  const [state, setState] = useState({
    disableSaveButton: true,
  });
  const { disableSaveButton } = state;

  const setDisableSaveButtonByNumberOfDirtyFormFields = (numberOfEmptyDirtyFields) => {
    if (numberOfEmptyDirtyFields > 0) {
      setDisableSaveButtonState(false);
    } else {
      setDisableSaveButtonState(true);
    }
  };

  const setDisableSaveButtonState = (value: boolean) => {
    setState((s) => (s.disableSaveButton === value ? s : { ...s, disableSaveButton: value }));
  };
  return { disableSaveButton, setDisableSaveButtonState, setDisableSaveButtonByNumberOfDirtyFormFields };
};
